import { validators } from "utils";
import * as Yup from "yup";

export interface ICewpUserFormSchema {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  certificationNumber: string;
  profileImageUrl: string;
  districts: string[];
}

export const CEWP_USER_STATUS_BADGE_OPTIONS = {
  Active: "bg-green-100 text-green-800",
  Suspended: "bg-amber-100 text-amber-800",
  Deleted: "bg-red-100 text-red-800",
};

export const CreateCewpUserSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phoneNumber: Yup.string()
    .matches(validators.PhoneNumberRegex, "Kindly enter a valid phone number")
    .required("Phone number is required"),
  emailAddress: Yup.string()
    .email("Kindly enter a valid email address")
    .required("Email address is required"),
  certificationNumber: Yup.string().required(
    "Certification number is required",
  ),
  profileImageUrl: Yup.string(),
  districts: Yup.array()
    .of(Yup.string())
    .transform((value) => (value || []).filter(Boolean))
    .min(1, "Kindly choose at least one district"),
});

export const UpdateCewpUserSchema = CreateCewpUserSchema;

export const getCreateCewpUserInitialValues = (
  districtId?: string,
): ICewpUserFormSchema => ({
  firstName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  certificationNumber: "",
  profileImageUrl: "",
  districts: districtId ? [districtId] : [""],
});

export const getUpdateCewpUserInitialValues = (): ICewpUserFormSchema => ({
  firstName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  certificationNumber: "",
  profileImageUrl: "",
  districts: [""],
});
